<!-- 头部导航 -->
<template>
    <div class="haedernav">
        <div class="haedernav-header-bgc">
            <div class="haedernav-header-box">

                <!-- 二维码 -->
                <div class="haedernav-header-erma flex-s">
                    <i></i>
                    <img @click="show = true" src="@/assets/icon/erweima.png" alt="" srcset="">
                </div>

                <!-- 医院信息 -->
                <div class="haedernav-header-boxbgc">
                    <img src="@/assets/logo.png" class="haedernav-header-logo" alt="" srcset="">
                    <div class="haedernav-header-box-top">
                        <i></i>
                        <div class="haedernav-header-box-right">
                            <div class="haedernav-header-rightItem">
                                <span class="header-span1">昨日浏览</span>
                                <span class="header-span2">4844</span>
                            </div>
                            <div class="haedernav-header-rightItem">|</div>
                            <div class="haedernav-header-rightItem">
                                <span class="header-span1">总浏览</span>
                                <span class="header-span2">299.1万</span>
                            </div>
                        </div>
                    </div>
                    <div class="haedernav-header-content">
                        <h1 class="haedernav-header-content-h1">郑州华夏白癜风医院</h1>

                        <div class="haedernav-header-content-div">
                            <span>白癜风</span><span>皮肤病</span>
                        </div>

                        <ul class="haedernav-header-contentfont">
                            <li class="haedernav-header-font-item">
                                <span class="font-item-span1">昨日浏览</span>
                                <span class="font-item-span2">4844</span>
                            </li>
                            <li class="haedernav-header-font-item">
                                <span class="font-item-span1">好评数</span>
                                <span class="font-item-span2">4844</span>
                            </li>
                            <li class="haedernav-header-font-item">
                                <span class="font-item-span1">好评率</span>
                                <span class="font-item-span2">50%</span>
                            </li>
                        </ul>

                        <div class="haedernav-header-contentaddress">
                            <div class="contentaddress-duan font_hiddles">
                                <strong class="strong"></strong>
                                <span>{{ Information.intrdetaile | FilterexText }}</span>
                                <div class="contentaddress-xiangqing" @click="Goabstract">【详情】</div>
                            </div>
                            <div class="haedernav-header-address">
                                <ul class="haedernav-header-address-left">
                                    <li class="haedernav-header-address-item font_hiddle">
                                        <strong class="haedernav-header-address-strong"></strong>
                                        <span>{{ Information.hosaddress }}</span>
                                    </li>
                                    <li class="haedernav-header-address-item font_hiddle">
                                        <strong class="haedernav-header-address-strong2"></strong>
                                        {{ Information.telephone }}(医院总机)
                                    </li>
                                </ul>
                                <div class="haedernav-header-address-right">
                                    <div class="address-right-item">
                                        <img src="@/assets/icon/address.png" @click="Goaddress" alt="" />
                                        <span>导航</span>
                                    </div>
                                    <i class="address-right-xian"></i>
                                    <div class="address-right-item">
                                        <img src="@/assets/icon/telephoto.png" @click="Makephone" alt="" />
                                        <span>电话</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 菜单栏目 -->
                    <ul class="haedernav-header-navlist">
                        <li class="header-navlist-item" v-for="(item, index) in NavList" @click="GoPageurl(item.url)"
                            :key="item.id">
                            <div class="header-navlist-item-icon">
                                <span v-if="index == 1" style="display: none;"
                                    class="header-navlist-item-span">5位坐诊医生</span>
                                <img :src="item.icon" alt="" srcset="">
                            </div>
                            <span class="header-navlist-item-text">{{ item.title }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 弹出层 -->
        <van-popup v-model="show" :closeable="true" class="haedernavvan-popup">
            <div class="haedernavvan-popup-img">
                <img src="@/assets/img/erweima.png" alt="" srcset="">
            </div>
        </van-popup>
    </div>
</template>

<script>
import { getintroducApi } from "@/api/resourceApi"

export default {
    data() {
        return {
            show: false,
            NavList: [
                {
                    id: "1",
                    title: "医院新闻",
                    icon: require("@/assets/img/yiyuan.png"),
                    url: "/news"
                },
                {
                    id: "2",
                    title: "医生团队",
                    icon: require("@/assets/img/yisheng.png"),
                    url: "/doctor"
                },
                {
                    id: "3",
                    title: "治疗技术",
                    icon: require("@/assets/img/zhiliao.png"),
                    url: "/techno"
                },
                {
                    id: "4",
                    title: "热点关注",
                    icon: require("@/assets/img/dongtai.png"),
                    url: "/follow"
                }
            ],
            Information: {}
        }
    },
    created() {
        this.getintroducApiRequest()
    },
    methods: {
        async getintroducApiRequest() {
            if (!this.$getVal("Information")) {
                let resout = await getintroducApi()
                this.$setVal("Information", JSON.stringify(resout.data))
            }
            this.Information = JSON.parse(this.$getVal("Information"))
        },
        Makephone() {
            this.$Telephone(this.Information.telephone)
        },
        GoPageurl(url) {
            this.$oneRouter(url)
        },
        Goaddress() {
            this.$oneRouter("/address")
        },
        Goabstract() {
            this.$oneRouter("/abstract")
        }
    },
}
</script>

<style lang="scss" scoped>
//头部
.haedernav {
    width: 100%;

    //头部背景
    .haedernav-header-bgc {
        width: 100%;
        height: auto;
        background: linear-gradient(180deg, #ECFBFA, #fff);

        .haedernav-header-box {
            width: 100%;
            height: 100%;
            padding: 10px;
            box-sizing: border-box;

            //二维码
            .haedernav-header-erma {
                width: 100%;

                img {
                    width: 25px;
                    height: 25px;
                }
            }

            //内容区
            .haedernav-header-boxbgc {
                width: 100%;
                height: auto;
                background-color: #fff;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
                border-radius: 10px;
                margin-top: 8px;
                position: relative;
                padding: 10px;
                box-sizing: border-box;

                //logo
                .haedernav-header-logo {
                    width: 60px;
                    height: 52px;
                    position: absolute;
                    left: 25px;
                    top: -25px;
                }

                .haedernav-header-box-top {
                    width: 100%;
                    height: 30px;
                    display: flex;
                    justify-content: space-between;
                    align-items: start;

                    .haedernav-header-box-right {
                        display: flex;
                        align-items: center;

                        .haedernav-header-rightItem {
                            font-size: 11px;
                            font-weight: 500;
                            margin-right: 10px;
                            color: #eee;

                            .header-span1 {
                                color: #888;
                            }

                            .header-span2 {
                                color: #00c8c8;
                                margin-left: 3px;
                            }
                        }
                    }
                }

                .haedernav-header-navlist {
                    width: 100%;
                    height: auto;
                    display: flex;
                    justify-content: space-between;
                    margin-top: 20px;
                    margin-bottom: 10px;

                    .header-navlist-item {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;

                        .header-navlist-item-icon {
                            width: 50px;
                            height: 50px;
                            background-color: #E8F6F6;
                            border-radius: 20px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            position: relative;

                            .header-navlist-item-span {
                                position: absolute;
                                top: -10px;
                                left: 0;
                                width: 55px;
                                border-radius: 5px;
                                background: #FD503E;
                                font-size: 8px;
                                width: 50px;
                                color: #fff;
                                text-align: center;
                                line-height: 13px;
                            }

                            img {
                                width: 23px;
                                height: 23px;
                            }
                        }

                        .header-navlist-item-text {
                            width: 53px;
                            margin-top: 8px;
                            font-size: 12px;
                            color: #000;
                        }
                    }
                }

                .haedernav-header-content {
                    width: 100%;
                    height: auto;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #eee;

                    .haedernav-header-contentaddress {
                        width: 100%;

                        .haedernav-header-address {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;

                            .haedernav-header-address-left {
                                flex: 1;
                                display: flex;
                                flex-direction: column;

                                .haedernav-header-address-item {
                                    width: 250px;
                                    font-size: 13px;
                                    color: #555;
                                    line-height: 23px;
                                    text-indent: 5px;

                                    .haedernav-header-address-strong {
                                        margin-right: 1px;
                                        background-image: url("@/assets/img/dizhi.png");
                                        width: 30px;
                                        height: 13px;
                                        display: inline-block;
                                        background-size: 100% 100%;
                                    }

                                    .haedernav-header-address-strong2 {
                                        margin-right: 1px;
                                        background-image: url("@/assets/img/dianhua.png");
                                        width: 30px;
                                        height: 13px;
                                        display: inline-block;
                                        background-size: 100% 100%;
                                    }
                                }
                            }

                            .haedernav-header-address-right {
                                width: 75px;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;

                                .address-right-xian {
                                    width: 1px;
                                    height: 35px;
                                    background-color: #eee;
                                }

                                .address-right-item {
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;

                                    img {
                                        width: 20px;
                                        height: 20px;
                                    }

                                    span {
                                        margin-top: 5px;
                                        font-size: 11px;
                                        color: #333;
                                    }
                                }
                            }
                        }

                        .contentaddress-duan {
                            width: 100%;
                            font-size: 13px;
                            color: #555;
                            line-height: 23px;
                            position: relative;
                            margin: 10px 0;
                            text-indent: 5px;

                            span {
                                margin-left: 5px;
                            }

                            .strong {
                                background-image: url("@/assets/img/jianjie.png");
                                width: 30px;
                                height: 13px;
                                display: inline-block;
                                background-size: 100% 100%;
                            }

                            .contentaddress-xiangqing {
                                position: absolute;
                                display: block;
                                right: 0;
                                bottom: 0;
                                width: 60px;
                                height: 26px;
                                line-height: 26px;
                                text-align: center;
                                background-color: #fff;
                                box-shadow: -6px 0 10px #eee;
                                font-size: 11px;
                                color: #666;
                                border-radius: 3px 0px 0px 3px;
                                padding: 0;
                            }
                        }
                    }

                    .haedernav-header-content-h1 {
                        font-size: 20px;
                        font-weight: bold;
                        color: #333;
                    }

                    .haedernav-header-content-div {
                        margin-top: 8px;
                        display: flex;
                        padding: 0 5px;
                        box-sizing: border-box;

                        span {
                            width: 35px;
                            height: 20px;
                            text-align: center;
                            line-height: 20px;
                            font-size: 10px;
                            color: #777;
                            background: #efefef;
                            border-radius: 5px;
                            margin-right: 10px;
                        }
                    }

                    .haedernav-header-contentfont {
                        display: flex;
                        align-items: center;
                        margin: 10px 0;

                        .haedernav-header-font-item {
                            font-size: 11px;
                            font-weight: 500;
                            margin-right: 15px;

                            .font-item-span1 {
                                color: #888;
                            }

                            .font-item-span2 {
                                color: #FD503E;
                                margin-left: 3px;
                            }
                        }
                    }
                }
            }
        }
    }


    //弹框
    .haedernavvan-popup {
        width: 95%;
        height: 600px;
        border-radius: 10px;
        padding: 10px;
        box-sizing: border-box;

        .haedernavvan-popup-img {
            width: 100%;
            height: 100%;
            padding-top: 50px;
            box-sizing: border-box;

            img {
                width: 100%;
                height: calc(100% - 30px);
            }
        }
    }
}
</style>